import * as React from 'react';
import cx from 'classnames';
import { withNativeProps } from '@/utils/with-native-props';
import isNil from 'lodash/isNil';
import isArray from 'lodash/isArray';
import './cn-readonly.scss';
const isEmpty = (value) => {
    if (isNil(value)) {
        // null or undefined
        return true;
    }
    if (value === '') {
        return true;
    }
    if (isArray(value) && !value.length) {
        return true;
    }
    return false;
};
export const CnReadonly = (props) => {
    const { children, emptyRender, isOverflowEllipsis } = props;
    const classes = cx({
        'cn-ui-m-readonly': true,
        'cn-ui-m-readonly-ellipsis': isOverflowEllipsis,
    });
    const itemRender = () => {
        if (isEmpty(children)) {
            return emptyRender();
        }
        return children;
    };
    return withNativeProps(props, React.createElement("div", { className: classes }, itemRender()));
};
CnReadonly.displayName = 'CnReadonly';
CnReadonly.defaultProps = {
    isOverflowEllipsis: true,
    emptyRender: () => '- -',
};
export const CnReadOnly = CnReadonly;
